import {GetterTree} from "vuex";
import {LoadingState} from "@/store/types/LoadingState";
import {RootState} from "@/store/types/RootState";

export const getters: GetterTree<LoadingState, RootState> = {
    isLoading: (state) => {
        return state.isLoading;
    },
    getBuild: (state) => {
        return state.build;
    },
}